import { formatApplicantName } from "../../applications/shared/format";
import type { SecuritySubjectRef } from "../types";

type Account = { firstName?: string | null; lastName?: string | null; email?: string | null } | null | undefined;

/** "RUT ···678-5" o null. */
export function rutTailLabel(subject: SecuritySubjectRef | null | undefined): string | null {
  return subject?.rutTail ? `RUT ···${subject.rutTail}` : null;
}

/**
 * Nombre de la persona en la lista: el de su cuenta Mixcore o, si no tiene,
 * el del carnet (o el final de su RUT).
 */
export function personName(user: Account, subject?: SecuritySubjectRef | null): string {
  const fromAccount = formatApplicantName(user);
  if (fromAccount !== "—") return fromAccount;
  return user?.email || subject?.displayName || rutTailLabel(subject) || "—";
}

/** Correo de la cuenta (si el caso está ligado a una) y final del RUT. */
export function personDetail(user: Account, subject?: SecuritySubjectRef | null): string {
  const parts = [user?.email, rutTailLabel(subject)].filter(Boolean);
  return parts.length ? parts.join(" · ") : "—";
}
